import { FolderForTree } from '@decisions/server/DecisionsFramework/ServiceLayer/Services/Folder';
import { IFolderTreeNode } from './FolderTree';
import { ITreeNode } from 'components/Tree/CommonTree/CommonTreeNode';
import { FolderForTreeWrapper } from '@decisions/server/DecisionsFramework/ServiceLayer/Services/Portal';

export const RecentFolderId = 'RecentFolderId';
export const SystemFolderID = 'SYSTEM FOLDER';
export const WorkflowCatalogId = 'SERVICE CATALOG FOLDER';

export function getValidOrderNumber(orderNumber: number): number {
  return orderNumber === 0 ? Number.MAX_VALUE : orderNumber;
}

export function sortFolderTreeNodes(nodeA: ITreeNode<IFolderTreeNode>, nodeB: ITreeNode<IFolderTreeNode>): number {
  const a = nodeA.data!.folderNode;
  const b = nodeB.data!.folderNode;
  const orderOfNodeA = getValidOrderNumber(a.FolderID === RecentFolderId ? -3 : a.OrderNum ?? 0);
  const orderOfNodeB = getValidOrderNumber(b.FolderID === RecentFolderId ? -3 : b.OrderNum ?? 0);
  if (orderOfNodeA < orderOfNodeB) {
    return -1;
  }
  if (orderOfNodeA > orderOfNodeB) {
    return 1;
  }
  if (orderOfNodeA && !orderOfNodeB) {
    return 1;
  }
  if (!orderOfNodeA && orderOfNodeB) {
    return -1;
  }

  if (a && b) {
    return a.FolderName.localeCompare(b.FolderName);
  } else {
    return 0;
  }
}

export function scrollToElement(parentContainer?: HTMLElement | null | undefined) {
  if (!IS_TEST && parentContainer) {
    // scroll after expanding delay
    setTimeout(() => {
      const node = parentContainer.querySelector(`.dp-common-tree-node--active`)?.closest('li');
      const contHeight = parentContainer?.clientHeight || 0;
      const elemHeight = node?.clientHeight || 0;

      if (elemHeight > contHeight) {
        node?.scrollIntoView({ block: 'start', behavior: 'smooth' });
      } else {
        const elemClientRect = node?.getBoundingClientRect();
        const scrollHolderClientRect = parentContainer?.getBoundingClientRect();

        if (
          (elemClientRect?.bottom || 0) > (scrollHolderClientRect?.bottom || 0) ||
          (elemClientRect?.top || 0) < (scrollHolderClientRect?.top || 0)
        ) {
          node?.scrollIntoView({ block: 'end', behavior: 'smooth' });
        }
      }
    }, 300);
  }
}

export function isFolderForTreeWrappers(
  possiblyWrapped: FolderForTreeWrapper[] | FolderForTree[]
): possiblyWrapped is FolderForTreeWrapper[] {
  return isFolderForTreeWrapper(possiblyWrapped[0]);
}

export function isFolderForTreeWrapper(
  possiblyWrapped: FolderForTreeWrapper | FolderForTree
): possiblyWrapped is FolderForTreeWrapper {
  return (possiblyWrapped as FolderForTreeWrapper).FolderForTree !== undefined;
}
